export default "/in_transit.6dd2341d-0ff6db.svg?svgr";